import { AppRouter } from "./router/AppRouter";
import { ToastContainer } from "./components/ToastContainer";
import { OfflineBanner } from "./components/OfflineBanner";
import { ImpersonationBanner } from "./components/ImpersonationBanner";

export default function App() {
  return (
    <>
      <ImpersonationBanner />
      <OfflineBanner />
      <AppRouter />
      <ToastContainer />
    </>
  );
}
